const state = {
  backRoute: undefined,
  lastClassesPath: undefined,
  userSettings: undefined,
  appleDetails: undefined,
  learnedLanguage: undefined,
  windowWidth: undefined,
  siteLanguage: undefined,
  userIsLoggedIn: undefined,
  sessionExpired: undefined,
  // forceWebViewStatus: false,
  dktDeeplinkParams: {
    dktAssignmentId: undefined,
    assignmentId: undefined,
    idpToken: undefined
  },
  handledUnauthorizedError: undefined,
  guestLink: undefined,
  guestError: undefined,
  appBannerVisible: true,
  narratorLanguage: undefined,
  wcag: {
    optionallyBiggerCursor: false,
    contrastMode: false
  }
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/settings/state.js